import { queryOptions } from "@tanstack/react-query";
import {
  createLabel,
  getLabelDeletionImpact,
  getLabels,
  removeLabel,
  updateLabel,
} from "api-client";

import { type Label, type LabelsRepository } from "./LabelsRepository";

export function createPersonalLabelsRepository(): LabelsRepository {
  const listOptions = queryOptions<Label[]>({
    queryKey: ["labels", "personal", "list"],
    async queryFn() {
      const response = await getLabels();
      return response.data.data;
    },
  });

  return {
    listOptions,
    async createLabel(input) {
      const response = await createLabel({ body: input });
      return response.data.data;
    },
    async getDeletionImpact(labelId: string) {
      const response = await getLabelDeletionImpact({ path: { id: labelId } });
      return response.data.data;
    },
    async removeLabel(labelId: string) {
      return removeLabel({ path: { id: labelId } });
    },
    async updateLabel(labelId, input) {
      return updateLabel({ path: { id: labelId }, body: input });
    },
  };
}
